
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface CartAlertsProps {
  session: any;
  items: Array<{ chef_id: string | null }>;
}

export const CartAlerts = ({ session, items }: CartAlertsProps) => {
  const navigate = useNavigate();

  return (
    <>
      {!session && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Authentication Required</AlertTitle>
          <AlertDescription>
            Please <Button variant="link" className="h-auto p-0 text-destructive" onClick={() => navigate('/auth')}>sign in</Button> to proceed with checkout.
          </AlertDescription>
        </Alert>
      )}

      {items.some(item => !item.chef_id) && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Invalid Items Detected</AlertTitle>
          <AlertDescription>
            Some items in your cart are missing required information. Please remove them to proceed with checkout.
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};
